export const updateStudent = `
mutation updateStudent ($id: ID!, $updatedAt: String!, $input: StudentUpdate!) {
    updateStudent (id: $id, updatedAt: $updatedAt, input: $input) {
        id
        createdAt
        updatedAt
    }
}
`;
export const createStudent = `mutation CreateStudent($input: StudentInsert!) {
  createStudent(input: $input) {
    id
  }
}
`;
